module.exports = __webpack_public_path__ + "img/crew_adv_10.ddeb0d0a.png";